import React from 'react';
import type { TemplateButton } from '../../types/message';

interface TemplateButtonsProps {
  buttons: TemplateButton[];
  onButtonClick?: (button: TemplateButton) => void;
}

const UrlIcon = () => (
  <svg className="w-4 h-4 text-[#00a884]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-4 h-4 text-[#00a884]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);

const ReplyIcon = () => (
  <svg className="w-4 h-4 text-[#00a884]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
  </svg>
);

const ButtonIcon: React.FC<{ type: string }> = ({ type }) => {
  switch (type) {
    case 'URL':
      return <UrlIcon />;
    case 'PHONE_NUMBER':
      return <PhoneIcon />;
    case 'QUICK_REPLY':
      return <ReplyIcon />;
    default:
      return null;
  }
};

export const TemplateButtons: React.FC<TemplateButtonsProps> = ({
  buttons,
  onButtonClick,
}) => {
  const handleClick = (button: TemplateButton) => {
    if (onButtonClick) {
      onButtonClick(button);
      return;
    }

    // Default click behavior
    if (button.type === 'URL' && button.url) {
      window.open(button.url, '_blank', 'noopener,noreferrer');
    } else if (button.type === 'PHONE_NUMBER' && button.phone_number) {
      window.location.href = `tel:${button.phone_number}`;
    }
  };

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {buttons.map((button, idx) => (
        <button
          key={idx}
          onClick={() => handleClick(button)}
          className="flex items-center gap-1.5 px-4 py-2 bg-warm-white border border-sketch rounded-lg hover:bg-cream active:bg-cream transition-colors shadow-sketch"
        >
          <ButtonIcon type={button.type} />
          <span className="text-sm font-medium text-[#00a884]">{button.text}</span>
        </button>
      ))}
    </div>
  );
};

export default TemplateButtons;
